import React, { ReactNode } from 'react';
import Documentupload from '../../../documentupload/documentupload';
import { REACT_APP_BASE_URL } from '../../../../config';
// import DocViewer from '@cyntler/react-doc-viewer'
import DocumentViewer from '../../../DocumentViewer/DocumentViewer';

export interface custommodalProps {
    children?: ReactNode;
    updateField?: any;
    payload?: any;
    name?: any;
}

const UploadStamp = ({
    updateField,
    payload,
    children,
    name
}: custommodalProps) => {
    return (
        <div className='w-full lg:w-[250px]'>
            {payload?.stamp ? (
                <>
                    <p className='text-sm font-medium mb-[10px] inline-block text-steelBlue lg:text-appcolorprimary lg:pb-[.5rem]'>
                        {name ? name : 'Stamp Image'}
                    </p>
                    <div className=' flex flex-col h-[126px] items-center justify-center border border-appcolorfaintnine p-4 rounded-[12px] lg:h-[50px] lg:w-[100px] preview-container lg:mb-4 lg:rounded-[3px] lg:border-appcolorfaintgreyblue lg:border-dashed lg:px-[.2rem] lg:py-[.2rem]'>
                        <DocumentViewer
                            fileUrl={`${REACT_APP_BASE_URL}/${payload?.stamp.split(
                                '/v1/'
                            )[1]}`}
                        />
                    </div>
                </>
            ) : (
                <Documentupload
                    acceptText='.jpg and .png'
                    accept='.jpg, .png'
                    useAuthorization
                    returnURLOnly
                    title={'Upload Stamp'}
                    afterUploadUpdate={(
                        itemId: number,
                        documentUrl: string
                    ) => {
                        updateField('stamp', documentUrl);
                    }}
                />
            )}
        </div>
    );
};

export default UploadStamp;
